import { render, staticRenderFns } from "./toggle-switch.vue?vue&type=template&id=19c11563&"
import script from "./toggle-switch.ts?vue&type=script&lang=ts&"
export * from "./toggle-switch.ts?vue&type=script&lang=ts&"
import style0 from "./toggle-switch.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports